module.exports = __webpack_public_path__ + "img/signature1.cef735b5.png";